import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingResources = new Set<string>();
  private isLoading = false;
  private loadingState$ = new Subject<boolean>();

  constructor() {}

  public startLoading(resourceName: string): void {
    this.loadingResources.add(resourceName);

    if (!this.isLoading && this.loadingResources.size > 0) {
      this.updateLoadingState(true);
    }
  }

  public stopLoading(resourceName: string): void {
    this.loadingResources.delete(resourceName);

    if (this.isLoading && this.loadingResources.size === 0) {
      this.updateLoadingState(false);
    }
  }

  private updateLoadingState(isLoading: boolean): void {
    this.isLoading = isLoading;
    this.loadingState$.next(this.isLoading);
  }

  public get loading$(): Observable<boolean> {
    return this.loadingState$.asObservable();
  }
}
